import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "HEALTH_SAFETY_ENVIRONMENT",
    applicationRights: Rights,
    title: 'HMS-data',
    text: 'HMS-data',
    icon: 'database',
    showOnDashboardByDefault: false,
    url: "/hse",
    mobileThreshold: 1024,
    sequenceNo: 10000,
    routes: Routes
})
